module.exports = __webpack_public_path__ + "media/fuel_types/lpg-e015e2af.png";